module.exports = __webpack_public_path__ + "static/files/uttam_sharma.4b4474b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uttam_sharma.jpg
// module id = 0U5y
// module chunks = 0